module.exports = __webpack_public_path__ + "img/D0002.464e00b2.svg";